export default __webpack_public_path__ + "static/media/img22.0059fcdb.jpg";